import React from 'react';
import { Link } from 'react-router-dom';
import { TYPE } from '../constants/typeScale';

/**
 * The catch-all route. An unknown address used to render nothing at all — a blank page with no way out.
 * Signed-in visitors following the link home are sent on to their dashboard by the landing page.
 */
const NotFound: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-secondary-50 dark:bg-black px-4">
    <div className="text-center flex flex-col items-center gap-2">
      <h1 className={`${TYPE.stageTitle} text-secondary-900 dark:text-white`}>This page does not exist</h1>
      <p className={`${TYPE.body} text-secondary-600 dark:text-secondary-400`}>
        The link may be old, or the address mistyped.
      </p>
      <Link
        to="/"
        className={`${TYPE.control} mt-2 px-3 py-1.5 rounded-md bg-secondary-900 text-white dark:bg-white dark:text-black font-medium`}
      >
        Go to Wisetree
      </Link>
    </div>
  </div>
);

export default NotFound;
